import { search } from "../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/financeiro/contasreceber/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findContasReceber({
  empresa_cnpj,
  include,
  id,
  where = {},
  wherein = {},
  whereEqual = {},
  orWhereHas = {},
  page,
  perPage = "50",
  fields,
  orWhere,
  whereDoesntHave = {},
  whereMoreEqual = {},
  whereLessEqual = {},
}) {
  let queryOrWhere = "";
  if (orWhere) {
    Object.keys(orWhere).forEach((key) => {
      queryOrWhere += `&orwhere[${key}]=${orWhere[key]}`;
    });
  }

  let query = "";
  Object.keys(where).forEach((value) => {
    query += `&where[${value}]=${where[value]}`;
  });

  let queryWhereEqual = "";
  Object.keys(whereEqual).forEach((value) => {
    queryWhereEqual += `&whereEqual[${value}]=${whereEqual[value]}`;
  });

  let queryHas = "";
  if (orWhereHas) {
    Object.keys(orWhereHas).forEach((key) => {
      queryHas += `&orwherehas[${key}]=${orWhereHas[key]}`;
    });
  }

  let queryWhereIn = "";
  Object.keys(wherein).forEach((row) => {
    queryWhereIn += `&wherein[${row}]=${wherein[row]}`;
  });

  let queryWhereMoreEqual = "";
  Object.keys(whereMoreEqual).forEach((row) => {
    queryWhereMoreEqual += `&whereMoreEqual[${row}]=${whereMoreEqual[row]}`;
  });

  let queryWhereLessEqual = "";
  Object.keys(whereLessEqual).forEach((row) => {
    queryWhereLessEqual += `&whereLessEqual[${row}]=${whereLessEqual[row]}`;
  });

  let queryWhereDoesntHave = "";
  Object.keys(whereDoesntHave).forEach((row) => {
    queryWhereDoesntHave += `&whereDoesntHave[${row}]=${JSON.stringify(
      whereDoesntHave[row]
    )}`;
  });

  return search(
    `${path}${id ? `/${id}` : ""}?empresa_cnpj=${empresa_cnpj}${
      include ? `&include=${include}` : ""
    }${query ?? ""}${queryOrWhere}${queryHas}${queryWhereIn ?? ""}${
      queryWhereDoesntHave ?? ""
    }${queryWhereMoreEqual ?? ""}${queryWhereLessEqual ?? ""}${
      queryWhereEqual ?? ""
    }${page ? `&page=${page}` : ""}${perPage ? `&per_page=${perPage}` : ""}${
      fields ? `&${fields}` : ""
    }`,
    "GET",
    headers
  );
}

export async function findCrByContracts({
  empresaCnpj,
  companyId,
  paramValues,
}) {
  let stringParam = "";
  Object.entries(paramValues).forEach(([key, value]) => {
    if (value) stringParam += `&${key}=${value}`;
  });
  return search(
    `${path}/contratovinculo?empresa_cnpj=${empresaCnpj}&companyId=${companyId}${stringParam}`,
    "GET",
    headers
  );
}

//AQUI DAMOS UM PUT PARA ENVIAR APENAS OS Q FICARÃO, AGINDO COMO UM DELETE TBM NOS Q N FORAM ENVIADOS <3
export const updateRevomeDespesa = async ({ empresa_cnpj, id, body }) => {
  return search(
    `${path}/${id}?empresa_cnpj=${empresa_cnpj}`,
    "PUT",
    headers,
    body
  );
};

export async function createContaReceber({ empresa_cnpj, body }) {
  return search(`${path}?empresa_cnpj=${empresa_cnpj}`, "POST", headers, body);
}
